import "./LandImg.css";
import { useHrStyles } from "../../Context/HRContext";
import { Button } from "react-bootstrap";

export default function LandImg() {
  const hrStyles = useHrStyles();

  return (
    <div className="interior-img-content">
      <h1 className="Int-heading">Landscaping Architecture</h1>
      <p className="Int-text">
        Landscaping is about creating a connection between architecture and
        nature. At BEAMS, we design outdoor spaces that are not only beautiful
        but also functional and sustainable. Our landscaping services integrate
        natural elements with thoughtful design, creating gardens, pathways, and
        outdoor living areas that enhance your environment. From creating
        serene, peaceful retreats to dynamic spaces for social gatherings, our
        designs ensure your outdoor areas are as inviting and thoughtfully
        crafted as your interiors.
      </p>
      <Button
        href="/Contact"
        variant="success"
        size="lg"
        className="centered-button"
      >
        Contact Us
      </Button>
      <hr style={hrStyles} />
    </div>
  );
}
